<template>
	<div>
		<div class="header px-0">
			<div>
				Enter Retailer Number
			</div>
		</div>
		<div class="pa-4">
			<div
				class="grey--text text--darken-2 body-2 font-weight-bold text-center pb-2"
			>
				This updation of the phone number is a mandatory step for all
				promoters.
			</div>
			<v-text-field
				type="text"
				label="Phone Number"
				v-model="retailerPhone"
				prepend-icon="phone"
				placeholder="Enter Phone Number"
				class="text-field-wrapper pt-4"
				:rules="[requiredRule, onlyDigitRule]"
				maxlength="10"
			></v-text-field>
			<div>
				<v-btn
					class="ma-0 mt-3 pa-4 white--text full-width btn"
					:color="themeInputColor"
					:loading="isLoading"
					@click="updateMapping"
					:disabled="
						/\D/g.test(retailerPhone) || retailerPhone.length !== 10
					"
					>UPDATE</v-btn
				>
			</div>
		</div>
	</div>
</template>
<script>
import * as utils from "@/utils";
import { UPSERT_PROMOTER_MAPPING } from "../../store/action-types";
export default {
	name: "PromoterMappingModal",
	data() {
		return {
			retailerPhone: null,
			isLoading: false,
			requiredRule: v => utils._requiredRule(v),
			onlyDigitRule: v => utils._onlyDigitsRule(v),
			themeInputColor: utils.themeInputColor
		};
	},
	methods: {
		updateMapping() {
			this.isLoading = true;
			this.$store
				.dispatch(UPSERT_PROMOTER_MAPPING.dispatch, {
					retailerPhone: Number("91" + this.retailerPhone)
				})
				.then(() => {
					this.$emit("fetchJeet11WalletDetails");
				})
				.catch(() => {})
				.finally(() => {
					this.isLoading = false;
				});
		}
	}
};
</script>
<style scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
	text-transform: capitalize;
}
</style>
